module.exports = __webpack_public_path__ + "static/media/SK.4e24378a.png";